import { Component, OnInit ,AfterViewInit } from '@angular/core';
import { HttpService } from '../../../http.service';
import { ShareddataService } from '../../../shareddata.service';
import { Router } from  '@angular/router';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-menu-one',
  templateUrl: './menu-one.component.html',
  styleUrls: ['./menu-one.component.css']
})
export class MenuOneComponent implements OnInit {
  menuResult: any;
  dealDataList: any=[];
  subMenuList: any=[];
  submenuSpin:any;
  menuSpin:any;
  res_name:any;
  responseHeaderData:any;
  selectedMenuid : any;
  message:String;
  apiCall : Number =0;
  isMenuFound = '1';
  BASEURL_SUBMENU_IMGS = environment.BASEURL_SUBMENU_IMGS;
  BASEURL_DEAL_IMGS = environment.BASEURL_DEAL_IMGS;
  constructor(private _http: HttpService, private sharedService: ShareddataService,		private route: ActivatedRoute,
) { }

	ngOnInit(): void {
		this.apiCall=0;
		this.sharedService.sharedMessage.subscribe((response: any) => { 
			if(response.data){
			this.responseHeaderData=response;
			if(this.responseHeaderData.data.guest_data.token){
				localStorage.setItem('jwt_token',this.responseHeaderData.data.guest_data.token);
				this.res_name=localStorage.getItem('res_name'); 
				if(this.apiCall==0 ){
					this.getMenu(1, 'yes');
					this.apiCall=1;
				}
			}
			}
		});
		this.route.queryParams.subscribe(params => {
			const storeId = params['store_id'];
			
			var savedStoreId = localStorage.getItem("url_store_id");	
			console.log(storeId);
			if (storeId!=savedStoreId && savedStoreId!=undefined) {
				// Here, you can refresh the page by triggering a reload
				localStorage.setItem("url_store_id", storeId);
				window.location.reload();
			}
			
			if (savedStoreId==undefined && storeId>0) {
				localStorage.setItem("url_store_id", storeId);
				window.location.reload();
			}
		  
		});
		
	}
  
  ngAfterViewInit() {
	
  }
  /* 
	* Function is used to load the getmenu on page load
  */
  getMenu(spinMenu, reloadMenu){
	var userId=25;
	if (this.responseHeaderData.data.guest_data) {
		if (this.responseHeaderData.data.guest_data.user_id) {
			userId = this.responseHeaderData.data.guest_data.user_id;
		}
	}

	var token=localStorage.getItem('jwt_token');
    if(reloadMenu==='yes') {
		this.menuSpin=spinMenu;
	}
	this.subMenuList=[];
	if (spinMenu == 0) {
		this.submenuSpin=1;
	}
	
	this._http.getRequest('restaurant_menu.php?res_id=49&user_id='+userId+'&call=web',token).subscribe((data:any) => {
			if(reloadMenu==='yes') {
				this.menuResult=[];
				this.menuSpin=0;
			}
			this.submenuSpin=0;
			if (data[0]) {
				if (data[0].status && data[0].status==="Failed") {
					this.isMenuFound = '0';
					return ;
				}	
				
			}
		  
		   if (data[0].is_deal==1 && reloadMenu==='yes') {
			this.menuResult.push({
				color: "#0000ff",
				created_at: "1608737155",
				id: "deal",
				name: "Deals",
				sequence: "1"
			}) ; 
		  }
		   if(reloadMenu==='yes') {
			   for (var i=0; i<data[0].Menu_Category.length; i++) {
					this.menuResult.push(data[0].Menu_Category[i]);
			   }
				this.menuSpin=0;			   
		   }
		  
		  
		  if(this.menuResult[0].id && data[0].is_deal==1){
			  this.dealDataList=data[0].deals_data;
			  this.getDealsData(this.menuResult[0]);
		  } else {
			this.getSubmenu(this.menuResult[0].id);
  
		  } 
		   localStorage.setItem('menu_reload', '1');
	
		}
	);
  }
  title = 'ngSlick';
  slides = [342, 453, 846, 855, 234, 564, 744, 243];

  slideConfig = {
    "slidesToShow": 6,
	"slidesToScroll": 1,
    "dots": false,
    "infinite": false,
	"arrows": true,
	"responsive": [

	{
      "breakpoint": 1024,
      "settings": {
        "slidesToShow": 6
      }
    },
	{
      "breakpoint": 700,
      "settings": {
        "slidesToShow": 6
      }
    },
    {
      "breakpoint": 600,
      "settings": {
        "slidesToShow": 2
      }
    }
    
  ]

  };

  slickInit(e) {
  }

  breakpoint(e) {
  }

  afterChange(e) {
  }

  beforeChange(e) {
  }

  getDealsData(data){
	var els = document.querySelectorAll('.menu-class')
    for (var i = 0; i < els.length; i++) {
		els[i].classList.remove('slected-menu')
    }
	this.subMenuList=[];
	setTimeout(function(){ 		
		if(document.getElementById('menu_deal')){
			(document.getElementById('menu_deal') as HTMLImageElement).classList.add("slected-menu");
		}
	}, 500);
	for (var i=0;i<this.dealDataList.length;i++) {
		this.subMenuList.push({
			is_size_applicable: '0',
			name: this.dealDataList[i].deal_name,
			desc: this.dealDataList[i].decription,
			id: this.dealDataList[i].deal_id,
			price: this.dealDataList[i].amount,
			image: this.dealDataList[i].image,
			dealData: this.dealDataList[i],
			disable: '0'
		});		
	}
  }
  
  getSubmenu(id){
	var submenu_image='menu_'+id;
	var els = document.querySelectorAll('.menu-class')
    for (var i = 0; i < els.length; i++) {
		els[i].classList.remove('slected-menu')
    }
	
    var token=localStorage.getItem('jwt_token');
	var userId=25;
	if (this.responseHeaderData.data.guest_data) {
		if (this.responseHeaderData.data.guest_data.user_id) {
			userId = this.responseHeaderData.data.guest_data.user_id;
		}
	}
	var queryParms='res_id=49&user_id='+userId+'&menucategory_id='+id+'&is_deal=0';
	this.submenuSpin=1;
	this.subMenuList=[];
    this._http.getRequest('restaurant_submenu.php?'+queryParms,token).subscribe(data => {
		  this.subMenuList = data[0].Menu_List;
		  this.submenuSpin=0;
	      if(document.getElementById(submenu_image)){
			(document.getElementById(submenu_image) as HTMLImageElement).classList.add("slected-menu");
		  }
		}
	);
  }
  
  updateUrl(result){
	var submenu_image='submenu_image_'+result;
	$('#'+submenu_image).remove();
	//(document.getElementById(submenu_image) as HTMLImageElement).src = 'assets/img/prods-sm/5.png';
  }
  
  /* Function is used to load the modifers data */
  getModifers(subMenuData){
	this.sharedService.nextSubMenuCart(subMenuData);
  }
 
}
